import find from "lodash/find";
import Dropdown from "./shared/Dropdown";
import EmojiAvatar from "./shared/EmojiAvatar";
import Emojify from "./shared/Emojify";
import Icon from "./shared/Icon";
import classNames from "classnames";

type Props = {
  currentClusterId?: string;
  unclustered: boolean;
  unclusteredPath: string;
  newClusterPath: string | null;
  clusters: Array<{
    id: string;
    name: string;
    path: string;
    color: string;
    emoji: string;
  }>;
};

export default function ClusterPicker({
  currentClusterId,
  unclustered,
  unclusteredPath,
  newClusterPath,
  clusters,
}: Props) {
  const currentCluster = find(clusters, { id: currentClusterId });

  return (
    <Dropdown
      className="block"
      width={270}
      nibOffsetX={-115}
      style={{ maxWidth: "270px" }}
    >
      <div
        className="flex items-center gap1.5 cursor-pointer"
        data-testid="clusters-dropdown-trigger"
      >
        <EmojiAvatar
          emoji={currentCluster?.emoji}
          color={currentCluster?.color}
          fallbackIcon={
            unclustered
              ? "custom/outline/broken-cluster"
              : "custom/outline/cluster"
          }
        />

        <Emojify
          className="h3 semi-bold m0 truncate line-height-2 charcoal-900"
          text={unclustered ? "Unclustered" : currentCluster?.name}
        />

        <Icon
          icon="down-triangle"
          className="flex-none"
          style={{ width: 7, height: 7 }}
        />
      </div>

      {unclusteredPath && (
        <div className="border-bottom border-gray mb1">
          <a
            key={unclusteredPath}
            className={classNames(
              "btn black hover-purple focus-purple flex items-center flex-none semi-bold gap1.5 py1 px1 mx1 my1 rounded",
              {
                "btn--activated purple bg-light-purple semi-bold": unclustered,
              },
            )}
            href={unclusteredPath}
          >
            <EmojiAvatar
              emoji={null}
              color={unclustered ? "#FFFFFF" : null}
              fallbackIcon="custom/outline/broken-cluster"
              className="very-dark-gray border border-white"
            />

            <Emojify text="Unclustered" className="truncate" />
          </a>
        </div>
      )}

      {clusters.map((cluster) => (
        <a
          key={cluster.path}
          className={classNames(
            "btn black hover-purple focus-purple flex items-center flex-none semi-bold gap1.5 py1 px1 mx1 rounded",
            {
              "btn--activated purple bg-light-purple semi-bold":
                currentClusterId === cluster.id,
            },
          )}
          href={cluster.path}
        >
          <EmojiAvatar
            emoji={cluster.emoji}
            color={cluster.color}
            fallbackIcon="custom/outline/cluster"
            className="very-dark-gray border border-white"
          />

          <Emojify text={cluster.name} className="truncate" />
        </a>
      ))}
      {newClusterPath !== null ? (
        <a
          className="btn black hover-purple focus-purple flex items-center flex-none semi-bold gap1.5 py1 px1 mx1 my1 rounded"
          href={newClusterPath}
        >
          <div
            className="flex items-center justify-center bg-gray-200"
            style={{ width: "40px", height: "40px", borderRadius: "50%" }}
          >
            <Icon
              icon="heroicons/outline/plus"
              className="flex-none"
              style={{ width: 24, height: 24 }}
            />
          </div>
          New Cluster
        </a>
      ) : null}
    </Dropdown>
  );
}
